import { e as _defineProperty } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import PropTypes from 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import { withTheme } from 'styled-components';
import './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import './box-e581bc98.js';
import { I as IconWrapper, g as getObjectValue } from './IconWrapper-f69d60c7-8a74d4d9.js';
import '@styled-system/grid';
import '@styled-system/background';
import './index.esm-f8e9e79f-5619e21b.js';

var AnalyticsIconV2 = function AnalyticsIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#0DB350"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3592 16.6666H13.2367C12.9898 16.6421 12.7571 16.5395 12.5725 16.3737C12.3879 16.208 12.2609 15.9877 12.21 15.7449L10.6467 8.49989L9.03669 12.2332C8.99115 12.3376 8.91607 12.4263 8.82071 12.4885C8.72535 12.5507 8.61387 12.5836 8.50002 12.5832H6.75002C6.59531 12.5832 6.44694 12.5218 6.33754 12.4124C6.22815 12.303 6.16669 12.1546 6.16669 11.9999C6.16669 11.8452 6.22815 11.6968 6.33754 11.5874C6.44694 11.478 6.59531 11.4166 6.75002 11.4166H8.11502L9.57919 8.03905C9.67775 7.81241 9.84574 7.62292 10.0589 7.4979C10.2721 7.37289 10.5195 7.31881 10.7655 7.34347C11.0114 7.36812 11.2431 7.47024 11.4272 7.63509C11.6114 7.79995 11.7384 8.01902 11.79 8.26072L13.3534 15.4999L14.9634 11.7782C15.0071 11.6717 15.0814 11.5805 15.1769 11.5161C15.2724 11.4518 15.3849 11.4171 15.5 11.4166H17.25C17.4047 11.4166 17.5531 11.478 17.6625 11.5874C17.7719 11.6968 17.8334 11.8452 17.8334 11.9999C17.8334 12.1546 17.7719 12.303 17.6625 12.4124C17.5531 12.5218 17.4047 12.5832 17.25 12.5832H15.885L14.4209 15.9607C14.3314 16.1687 14.1835 16.3461 13.995 16.4715C13.8064 16.5968 13.5855 16.6646 13.3592 16.6666Z",
    fill: "white"
  })));
};
AnalyticsIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AnalyticsIconV2"
};

var ConversationStudio = function ConversationStudio(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#0056B8"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.33327 10.3625V13.6351H5.99994V10.3625H7.33327ZM17.9999 10.3625V13.6351H16.6666V10.3625H17.9999Z",
    fill: "white",
    stroke: "white",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16.9093 9.58488V16.5974C16.9093 17.372 16.2813 17.9999 15.5067 17.9999H8.49372C7.71909 17.9999 7.09113 17.372 7.09113 16.5974V9.58488C7.09113 8.8103 7.71909 8.18237 8.49372 8.18237H15.5067C16.2813 8.18237 16.9093 8.8103 16.9093 9.58488Z",
    fill: "white",
    stroke: "white",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8181 11.9551C9.84323 11.9551 9.86355 11.9754 9.86355 12.0005C9.86355 12.0255 9.84323 12.0459 9.8181 12.0459C9.79296 12.0459 9.77264 12.0255 9.77264 12.0005C9.77264 11.9754 9.79296 11.9551 9.8181 11.9551Z",
    fill: "#0056B8",
    stroke: "#0056B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.181 11.9551C14.2061 11.9551 14.2265 11.9754 14.2265 12.0005C14.2265 12.0255 14.2061 12.0459 14.181 12.0459C14.1559 12.0459 14.1356 12.0255 14.1356 12.0005C14.1356 11.9754 14.1559 11.9551 14.181 11.9551Z",
    fill: "#0056B8",
    stroke: "#0056B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5453 6V8.18167",
    stroke: "white",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7276 14.7275V15.8184H10.364V14.7275",
    stroke: "#0056B8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })));
};
ConversationStudio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ConversationStudio"
};

var DocumentationIcon = function DocumentationIcon(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9695 2.18789C20.2607 2.0658 19.5429 2.00295 18.8237 2C16.3697 1.99799 13.9669 2.70167 11.9017 4.02716C9.83117 2.71907 7.42874 2.03267 4.97969 2.04945C4.26044 2.05239 3.54269 2.11524 2.83387 2.23733C2.60169 2.27736 2.39144 2.39897 2.24097 2.58026C2.09049 2.76155 2.0097 2.99061 2.01312 3.22619V15.0925C2.011 15.2378 2.04093 15.3817 2.10078 15.5141C2.16063 15.6466 2.24893 15.7642 2.35939 15.8586C2.46985 15.953 2.59977 16.0219 2.73989 16.0604C2.88001 16.0989 3.02689 16.106 3.17008 16.0813C4.58713 15.836 6.03895 15.8767 7.44003 16.201C8.8411 16.5254 10.1631 17.1269 11.3281 17.97L11.4468 18.0393H11.5556C11.6653 18.0849 11.7829 18.1085 11.9017 18.1085C12.0205 18.1085 12.1381 18.0849 12.2478 18.0393H12.3566L12.4752 17.97C13.6321 17.108 14.9503 16.4871 16.3517 16.144C17.753 15.8008 19.209 15.7426 20.6333 15.9725C20.7765 15.9973 20.9234 15.9901 21.0635 15.9516C21.2036 15.9131 21.3335 15.8442 21.444 15.7498C21.5544 15.6554 21.6427 15.5378 21.7026 15.4054C21.7624 15.273 21.7924 15.129 21.7902 14.9837V3.11741C21.78 2.8921 21.693 2.67708 21.5437 2.50802C21.3944 2.33895 21.1918 2.22599 20.9695 2.18789ZM10.9128 15.3298C9.08333 14.3673 7.04691 13.865 4.97969 13.8663C4.65337 13.8663 4.32704 13.8663 3.99083 13.8663V3.97772C4.32018 3.95874 4.65034 3.95874 4.97969 3.97772C7.0893 3.97539 9.15288 4.59446 10.9128 5.75766V15.3298ZM19.8125 13.9058C19.4763 13.9058 19.15 13.9058 18.8237 13.9058C16.7565 13.9046 14.72 14.4069 12.8905 15.3693V5.75766C14.6505 4.59446 16.7141 3.97539 18.8237 3.97772C19.153 3.95874 19.4832 3.95874 19.8125 3.97772V13.9058ZM20.9695 18.0096C20.2607 17.8875 19.5429 17.8247 18.8237 17.8217C16.3697 17.8197 13.9669 18.5234 11.9017 19.8489C9.83647 18.5234 7.43367 17.8197 4.97969 17.8217C4.26044 17.8247 3.54269 17.8875 2.83387 18.0096C2.70515 18.03 2.58174 18.0757 2.47073 18.144C2.35972 18.2123 2.2633 18.3018 2.18703 18.4075C2.11075 18.5132 2.05612 18.6329 2.02628 18.7598C1.99643 18.8867 1.99196 19.0182 2.01312 19.1468C2.06337 19.4036 2.21335 19.63 2.43021 19.7764C2.64707 19.9228 2.91312 19.9773 3.17008 19.928C4.58713 19.6826 6.03895 19.7233 7.44003 20.0477C8.8411 20.3721 10.1631 20.9735 11.3281 21.8167C11.4956 21.9359 11.6961 22 11.9017 22C12.1073 22 12.3077 21.9359 12.4752 21.8167C13.6403 20.9735 14.9623 20.3721 16.3633 20.0477C17.7644 19.7233 19.2162 19.6826 20.6333 19.928C20.8903 19.9773 21.1563 19.9228 21.3732 19.7764C21.59 19.63 21.74 19.4036 21.7902 19.1468C21.8114 19.0182 21.8069 18.8867 21.7771 18.7598C21.7472 18.6329 21.6926 18.5132 21.6163 18.4075C21.5401 18.3018 21.4437 18.2123 21.3326 18.144C21.2216 18.0757 21.0982 18.03 20.9695 18.0096Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
DocumentationIcon.propTypes = {
  iconColor: PropTypes.string
};
DocumentationIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DocumentationIcon",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var DocumentationIcon$1 = withTheme(DocumentationIcon);

var HelpIconV2 = function HelpIconV2(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7708 5.02105C16.0005 5.15829 16.2724 5.19436 16.5273 5.12139C16.7821 5.04843 16.9992 4.87235 17.1311 4.63158C17.2403 4.4288 17.4104 4.26989 17.6146 4.17977C17.8188 4.08965 18.0457 4.07342 18.2597 4.13363C18.4736 4.19383 18.6626 4.32706 18.7968 4.51243C18.9311 4.6978 19.0031 4.92482 19.0015 5.15789C19.0015 5.43707 18.8961 5.70481 18.7086 5.90222C18.521 6.09962 18.2666 6.21053 18.0013 6.21053C17.736 6.21053 17.4816 6.32143 17.294 6.51883C17.1065 6.71624 17.0011 6.98398 17.0011 7.26316C17.0011 7.54233 17.1065 7.81007 17.294 8.00748C17.4816 8.20489 17.736 8.31579 18.0013 8.31579C18.5279 8.31543 19.0452 8.16922 19.5011 7.89183C19.9571 7.61444 20.3356 7.21565 20.5987 6.73553C20.8618 6.25541 21.0002 5.71087 21 5.15663C20.9998 4.60239 20.861 4.05797 20.5975 3.57807C20.334 3.09817 19.9552 2.6997 19.4991 2.4227C19.0429 2.14569 18.5255 1.99991 17.9989 2C17.4723 2.00009 16.9549 2.14605 16.4989 2.4232C16.0428 2.70036 15.6641 3.09896 15.4008 3.57895C15.3346 3.69909 15.2917 3.83181 15.2745 3.96947C15.2574 4.10713 15.2662 4.24701 15.3006 4.38106C15.335 4.5151 15.3943 4.64065 15.475 4.75049C15.5557 4.86033 15.6562 4.95228 15.7708 5.02105ZM20.0717 12.5263C19.8092 12.4905 19.5438 12.5656 19.3338 12.7353C19.1239 12.905 18.9864 13.1554 18.9515 13.4316C18.7416 15.216 17.919 16.858 16.6386 18.0484C15.3583 19.2388 13.7085 19.8955 12.0001 19.8947H6.40889L7.05903 19.2105C7.24532 19.0133 7.34988 18.7465 7.34988 18.4684C7.34988 18.1903 7.24532 17.9235 7.05903 17.7263C6.08378 16.6959 5.42007 15.3848 5.15153 13.9582C4.88298 12.5315 5.02159 11.0532 5.54992 9.70929C6.07824 8.36541 6.97263 7.21612 8.12044 6.4062C9.26825 5.59627 10.6181 5.16193 12.0001 5.15789C12.2653 5.15789 12.5197 5.04699 12.7073 4.84959C12.8949 4.65218 13.0003 4.38444 13.0003 4.10526C13.0003 3.82609 12.8949 3.55835 12.7073 3.36094C12.5197 3.16353 12.2653 3.05263 12.0001 3.05263C10.3089 3.06006 8.65401 3.56867 7.22486 4.5202C5.79571 5.47174 4.65016 6.82771 3.91944 8.43276C3.18872 10.0378 2.90239 11.827 3.09325 13.5954C3.28411 15.3638 3.94445 17.0399 4.9986 18.4316L3.28825 20.2C3.14946 20.348 3.05544 20.536 3.01806 20.7402C2.98068 20.9444 3.00161 21.1557 3.0782 21.3474C3.15324 21.5396 3.28066 21.7042 3.44442 21.8203C3.60817 21.9364 3.80093 21.999 3.99839 22H12.0001C14.192 22.0003 16.3087 21.159 17.9531 19.6338C19.5975 18.1086 20.6567 16.0043 20.9319 13.7158C20.9502 13.5782 20.9424 13.4381 20.909 13.3036C20.8756 13.1692 20.8172 13.0431 20.7373 12.9325C20.6573 12.8219 20.5573 12.7291 20.4431 12.6594C20.3289 12.5896 20.2026 12.5444 20.0717 12.5263V12.5263ZM18.3814 9.4421C18.1993 9.35732 17.9973 9.33166 17.8013 9.36842L17.6212 9.43158L17.4412 9.52632L17.2912 9.66316C17.2012 9.76016 17.1299 9.87453 17.0811 10C17.022 10.1313 16.9945 10.2759 17.0011 10.4211C16.9982 10.5614 17.022 10.701 17.0711 10.8316C17.1228 10.9579 17.1976 11.0724 17.2912 11.1684C17.3846 11.266 17.4955 11.3432 17.6173 11.3955C17.7392 11.4479 17.8697 11.4745 18.0013 11.4737C18.2666 11.4737 18.521 11.3628 18.7086 11.1654C18.8961 10.968 19.0015 10.7002 19.0015 10.4211C19.0049 10.283 18.9775 10.146 18.9215 10.0211C18.814 9.76811 18.6217 9.56574 18.3814 9.45263V9.4421Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.grey.deep)
  })));
};
HelpIconV2.propTypes = {
  iconColor: PropTypes.string
};
HelpIconV2.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HelpIconV2",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var HelpIconV2$1 = withTheme(HelpIconV2);

var _CAS_URLS_MAP;
var CONSTANTS = {
  PLATFORM_SUPPORT: "Help",
  SIGN_OUT: "Sign Out",
  PERMISSION_MANAGEMENT: "Permission Management",
  AUDIT_DASHBOARD: "Audit Dashboard",
  PROACTIVE_MESSAGING: "Interakt",
  BB: "CS",
  ANALYTICS: "IA",
  AGENT_CHAT: "Smart Agent Chat",
  PROFILE: "Profile",
  DOCS: "Docs",
  CREATE_NEW_IVA: "Create new Bot",
  CREATE_NEW_SMARTSKILL: "Create new Smart Skill",
  STAGING: "staging",
  PROD: "production",
  // For Local Storage
  KEYS: {
    CURRENT_IVA: "ww_iva",
    CURRENT_ENV: "ww_env",
    CURRENT_IVA_BUSINESSES: "iva_businesses"
  }
};
var ROUTES = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CONSTANTS.BB, "/mogambo/"), CONSTANTS.ANALYTICS, "/dashboard/"), CONSTANTS.CREATE_NEW_IVA, "/home_v2/#/create-bot/"), CONSTANTS.PERMISSION_MANAGEMENT, "/admin_tools/permissions/"), CONSTANTS.AUDIT_DASHBOARD, "/admin_tools/audit_dashboard/"), CONSTANTS.PROFILE, "/profile/"), CONSTANTS.DOCS, "https://docs.haptik.ai/"), CONSTANTS.AGENT_CHAT, "/athena/"), "SMART_SKILLS", "/mogambo/#/smart-skills");
var PERMISSIONS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CONSTANTS.BB, "mogambo_all_view"), CONSTANTS.ANALYTICS, "iva_analytics_all_view"), CONSTANTS.PERMISSION_MANAGEMENT, "permissions_admin_experts_view"), CONSTANTS.AUDIT_DASHBOARD, "permissions_admin_experts_view"), CONSTANTS.PROACTIVE_MESSAGING, "manage_proactive_messaging"), CONSTANTS.PLATFORM_SUPPORT, "platform_support_bot_user"), CONSTANTS.AGENT_CHAT, "athena_tool_access"), "SMART_SKILLS", "smart_skills_edit");
var DEFAULTS = {
  height: 64,
  border: 0,
  padding: 0,
  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  alignItems: "center",
  // Logo
  logoSize: 64,
  // Action
  actionHeight: 38,
  // Tools
  TOOLS: [{
    ICON_PREFIX: CONSTANTS.BB,
    NAME: "Conversation Studio",
    PERMISSION: PERMISSIONS[CONSTANTS.BB],
    ICON: /*#__PURE__*/React.createElement(ConversationStudio, null),
    NAV: ROUTES[CONSTANTS.BB]
  }, {
    ICON_PREFIX: CONSTANTS.ANALYTICS,
    NAME: "Intelligent Analytics",
    PERMISSION: PERMISSIONS[CONSTANTS.ANALYTICS],
    ICON: /*#__PURE__*/React.createElement(AnalyticsIconV2, null),
    NAV: ROUTES[CONSTANTS.ANALYTICS]
  }],
  // Popup Offset
  POPUP_TOP_OFFSET: 60,
  // RHS Action Icons
  RHS_ACTION_ICONS: [{
    ICON_PREFIX: CONSTANTS.DOCS,
    TOOLTIP: CONSTANTS.DOCS,
    NAV: ROUTES[CONSTANTS.DOCS],
    ICON: /*#__PURE__*/React.createElement(DocumentationIcon$1, null)
  }, {
    ICON_PREFIX: CONSTANTS.PLATFORM_SUPPORT,
    TOOLTIP: CONSTANTS.PLATFORM_SUPPORT,
    ICON: /*#__PURE__*/React.createElement(HelpIconV2$1, null),
    PERMISSION: PERMISSIONS[CONSTANTS.PLATFORM_SUPPORT]
  }],
  // Account Popup Items
  ACCOUNT_POPUP_ITEMS: [{
    TITLE: CONSTANTS.PROFILE,
    SEPERATOR: true,
    NAV: ROUTES[CONSTANTS.PROFILE]
  }, {
    EXTRA: false,
    GROUP: [{
      TITLE: CONSTANTS.PERMISSION_MANAGEMENT,
      PERMISSION: PERMISSIONS[CONSTANTS.PERMISSION_MANAGEMENT],
      NAV: ROUTES[CONSTANTS.PERMISSION_MANAGEMENT]
    }, {
      TITLE: CONSTANTS.AUDIT_DASHBOARD,
      PERMISSION: PERMISSIONS[CONSTANTS.AUDIT_DASHBOARD],
      NAV: ROUTES[CONSTANTS.AUDIT_DASHBOARD],
      SEPERATOR: true
    }, {
      TITLE: CONSTANTS.PROACTIVE_MESSAGING,
      PERMISSION: PERMISSIONS[CONSTANTS.PROACTIVE_MESSAGING]
    }, {
      TITLE: CONSTANTS.AGENT_CHAT,
      PERMISSION: PERMISSIONS[CONSTANTS.AGENT_CHAT],
      SEPERATOR: true,
      NAV: ROUTES[CONSTANTS.AGENT_CHAT]
    }]
  }, {
    EXTRA: true,
    // These will only be rendered when resolution is ~1024px
    GROUP: [{
      TITLE: CONSTANTS.DOCS,
      ICON: /*#__PURE__*/React.createElement(DocumentationIcon$1, {
        size: "small"
      }),
      NAV: ROUTES[CONSTANTS.DOCS]
    }, {
      TITLE: CONSTANTS.PLATFORM_SUPPORT,
      ICON: /*#__PURE__*/React.createElement(HelpIconV2$1, {
        size: "small"
      }),
      PERMISSION: PERMISSIONS[CONSTANTS.PLATFORM_SUPPORT],
      SEPERATOR: true
    }]
  }, {
    TITLE: CONSTANTS.SIGN_OUT
  }],
  // API ENDPOINTS
  API_ENDPOINTS: {
    GET_ALL_BOTS: "/mogambo_api/domain/",
    DOMAIN_DATA: "/mogambo_api/domain/data/",
    GET_ALL_SMART_SKILLS: "/mogambo_api/templates/",
    PROACTIVE_MESSAGING: "/admin_tools/interakt_auth/"
  }
};

// CAS URLS
var HAPTIK_STAGING = "https://staging.hellohaptik.com";
var HAPTIK_PROD = "https://api.haptikapi.com";
var HAPTIK_US_STAGING = "https://haptik-us-preprod.hellohaptik.com";
var HAPTIK_US_PROD = "https://haptik-us.haptikapi.com";
var D11_STAGING = "https://haptik-d11-preprod.hellohaptik.com";
var D11_PROD = "https://haptik-d11.haptikapi.com";
var MYGOV_STAGING = "https://haptik-mygov-preprod.hellohaptik.com/";
var MYGOV_PROD = "https://haptik-mygov.haptikapi.com/";
var SINGAPORE_STAGING = "https://singapore-preprod.hellohaptik.com";
var SINGAPORE_PROD = "https://singapore.haptikapi.com";
var JIO_STAGING = "https://jio-api.hellohaptik.com";
var JIO_PROD = "https://jio-api.haptikapi.com";
var NSDC_STAGING = "https://nsdc-api.betalaunch.in";
var NSDC_PROD = "https://nsdc-api.skillindiadigital.gov.in";
var FANCODE_STAGING = "https://haptik-fancode-api.hellohaptik.com";
var FANCODE_PROD = "https://haptik-fancode-api.haptikapi.com";
var CAS_URLS_MAP = (_CAS_URLS_MAP = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CAS_URLS_MAP, HAPTIK_STAGING, HAPTIK_PROD), HAPTIK_PROD, HAPTIK_STAGING), HAPTIK_US_STAGING, HAPTIK_US_PROD), HAPTIK_US_PROD, HAPTIK_US_STAGING), D11_STAGING, D11_PROD), D11_PROD, D11_STAGING), MYGOV_STAGING, MYGOV_PROD), MYGOV_PROD, MYGOV_STAGING), SINGAPORE_STAGING, SINGAPORE_PROD), SINGAPORE_PROD, SINGAPORE_STAGING), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_CAS_URLS_MAP, JIO_STAGING, JIO_PROD), JIO_PROD, JIO_STAGING), NSDC_STAGING, NSDC_PROD), NSDC_PROD, NSDC_STAGING), FANCODE_STAGING, FANCODE_PROD), FANCODE_PROD, FANCODE_STAGING));

// Mixpanel constants
var MIXPANEL = {
  BOT_CLICKED: "BotName_Clicked",
  CREATE_BOT_CLICKED: "CreateBot_Clicked",
  BOT_SEARCHED: "BotName_Searched",
  CS_CLICKED: "CS_ConversationStudio_Clicked",
  IA_CLICKED: "IA_IntelligentAnalytics_Clicked",
  BOT_ENV_CLICKED: "BotEnvironment_Clicked",
  DOCS_CLICKED: "Docs_Clicked",
  WHATS_NEW_CLICKED: "WhatsNew_Clicked",
  HELP_CLICKED: "HelpBot_Clicked",
  PROM_CLICKED: "Proactive_Messaging_Clicked",
  PROM_CHANNEL_CLICK: "ProM_Channel_Click"
};

// ProM Channels

var PRO_M_CHANNEL = {
  SMS: "sms",
  WHATSAPP: "whatsapp"
};

export { CONSTANTS as C, DEFAULTS as D, MIXPANEL as M, PRO_M_CHANNEL as P, ROUTES as R, PERMISSIONS as a, CAS_URLS_MAP as b };
